const SET_CURRENT_PROJECT = 'magblocks/SET_CURRENT_PROJECT';
const CLEAR_CURRENT_PROJECT = 'magblocks/CLEAR_CURRENT_PROJECT';
const SET_PROJECTS_LIST = 'magblocks/SET_PROJECTS_LIST';
const REMOVE_PROJECT = 'magblocks/REMOVE_PROJECT';
const SET_SAVING = 'magblocks/SET_SAVING';
const SET_LOADING = 'magblocks/SET_LOADING';

const initialState = {
    currentProjectId: null,
    currentProjectName: null,
    isSaving: false,
    isLoading: false,
    projects: []
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_CURRENT_PROJECT:
        return {
            ...state,
            currentProjectId: action.id,
            currentProjectName: action.name
        };
    case CLEAR_CURRENT_PROJECT:
        return {
            ...state,
            currentProjectId: null,
            currentProjectName: null
        };
    case SET_PROJECTS_LIST:
        return {...state, projects: action.projects};
    case REMOVE_PROJECT:
        return {...state, projects: state.projects.filter(p => p.id !== action.id)};
    case SET_SAVING:
        return {...state, isSaving: action.value};
    case SET_LOADING:
        return {...state, isLoading: action.value};
    default:
        return state;
    }
};

const setCurrentProject = (id, name) => ({type: SET_CURRENT_PROJECT, id, name});
const clearCurrentProject = () => ({type: CLEAR_CURRENT_PROJECT});
const setProjectsList = projects => ({type: SET_PROJECTS_LIST, projects});
const removeProject = id => ({type: REMOVE_PROJECT, id});
const setMagblocksSaving = value => ({type: SET_SAVING, value});
const setMagblocksLoading = value => ({type: SET_LOADING, value});

export {
    reducer as default,
    initialState as magblocksProjectInitialState,
    setCurrentProject,
    clearCurrentProject,
    setProjectsList,
    removeProject,
    setMagblocksSaving,
    setMagblocksLoading
};
